import React from "react";
import { FaChevronLeft } from "react-icons/fa";

export const ProjectDetails = () => {
  return (
    <div className="project-details">
      <a className="back-to-projects" href="/projects">
        <span>
          <FaChevronLeft />
        </span>
        <p>Back to projects</p>
      </a>
      <h1 className="project-title-info">Thom Pulian y Ricardo | El portal</h1>
      <h2 className="work-description">
        Residential Complete interior remodel
      </h2>
      <p className="work-details">
        New impact windows, new kitchen, new bathrooms, new floor plan layout,
        reinforcing of roof and wall structures
      </p>
    </div>
  );
};
